import { render, staticRenderFns } from "./Topografia.vue?vue&type=template&id=f1223cfc&scoped=true"
import script from "./Topografia.vue?vue&type=script&lang=js"
export * from "./Topografia.vue?vue&type=script&lang=js"
import style0 from "./Topografia.vue?vue&type=style&index=0&id=f1223cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1223cfc",
  null
  
)

export default component.exports